/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * exemONE SSO Api
 * OpenAPI spec version: 1.0.0
 */
import { useMutation } from '@tanstack/vue-query';
import type {
  MutationFunction,
  QueryClient,
  UseMutationOptions,
  UseMutationReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  FidoReqResponse,
  FidoResResponse,
  OtpResponse,
  PostV7HyundaiSsoOtpParams,
  SsoFidoReqRequest,
  SsoFidoResRequest,
  SsoOtpRequest,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getRequestFido
 */
export const postV7HyundaiSsoFidoReq = (
  ssoFidoReqRequest: MaybeRef<SsoFidoReqRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  ssoFidoReqRequest = unref(ssoFidoReqRequest);

  return customAxiosInstance<FidoReqResponse>(
    {
      url: `/api/v7/hyundai/sso/fido/req`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: ssoFidoReqRequest,
      signal,
    },
    options,
  );
};

export const getPostV7HyundaiSsoFidoReqMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>,
    TError,
    { data: BodyType<SsoFidoReqRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>,
  TError,
  { data: BodyType<SsoFidoReqRequest> },
  TContext
> => {
  const mutationKey = ['postV7HyundaiSsoFidoReq'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>,
    { data: BodyType<SsoFidoReqRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7HyundaiSsoFidoReq(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7HyundaiSsoFidoReqMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>
>;
export type PostV7HyundaiSsoFidoReqMutationBody = BodyType<SsoFidoReqRequest>;
export type PostV7HyundaiSsoFidoReqMutationError = ErrorType<unknown>;

/**
 * @summary getRequestFido
 */
export const usePostV7HyundaiSsoFidoReq = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>,
      TError,
      { data: BodyType<SsoFidoReqRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoReq>>,
  TError,
  { data: BodyType<SsoFidoReqRequest> },
  TContext
> => {
  const mutationOptions = getPostV7HyundaiSsoFidoReqMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getResponseFido
 */
export const postV7HyundaiSsoFidoRes = (
  ssoFidoResRequest: MaybeRef<SsoFidoResRequest>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  ssoFidoResRequest = unref(ssoFidoResRequest);

  return customAxiosInstance<FidoResResponse>(
    {
      url: `/api/v7/hyundai/sso/fido/res`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: ssoFidoResRequest,
      signal,
    },
    options,
  );
};

export const getPostV7HyundaiSsoFidoResMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>,
    TError,
    { data: BodyType<SsoFidoResRequest> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>,
  TError,
  { data: BodyType<SsoFidoResRequest> },
  TContext
> => {
  const mutationKey = ['postV7HyundaiSsoFidoRes'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>,
    { data: BodyType<SsoFidoResRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7HyundaiSsoFidoRes(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7HyundaiSsoFidoResMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>
>;
export type PostV7HyundaiSsoFidoResMutationBody = BodyType<SsoFidoResRequest>;
export type PostV7HyundaiSsoFidoResMutationError = ErrorType<unknown>;

/**
 * @summary getResponseFido
 */
export const usePostV7HyundaiSsoFidoRes = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>,
      TError,
      { data: BodyType<SsoFidoResRequest> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7HyundaiSsoFidoRes>>,
  TError,
  { data: BodyType<SsoFidoResRequest> },
  TContext
> => {
  const mutationOptions = getPostV7HyundaiSsoFidoResMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary getOtp
 */
export const postV7HyundaiSsoOtp = (
  ssoOtpRequest: MaybeRef<SsoOtpRequest>,
  params?: MaybeRef<PostV7HyundaiSsoOtpParams>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  ssoOtpRequest = unref(ssoOtpRequest);
  params = unref(params);

  return customAxiosInstance<OtpResponse>(
    {
      url: `/api/v7/hyundai/sso/otp`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: ssoOtpRequest,
      params: unref(params),
      signal,
    },
    options,
  );
};

export const getPostV7HyundaiSsoOtpMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>,
    TError,
    { data: BodyType<SsoOtpRequest>; params?: PostV7HyundaiSsoOtpParams },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>,
  TError,
  { data: BodyType<SsoOtpRequest>; params?: PostV7HyundaiSsoOtpParams },
  TContext
> => {
  const mutationKey = ['postV7HyundaiSsoOtp'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>,
    { data: BodyType<SsoOtpRequest>; params?: PostV7HyundaiSsoOtpParams }
  > = (props) => {
    const { data, params } = props ?? {};

    return postV7HyundaiSsoOtp(data, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7HyundaiSsoOtpMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>
>;
export type PostV7HyundaiSsoOtpMutationBody = BodyType<SsoOtpRequest>;
export type PostV7HyundaiSsoOtpMutationError = ErrorType<unknown>;

/**
 * @summary getOtp
 */
export const usePostV7HyundaiSsoOtp = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>,
      TError,
      { data: BodyType<SsoOtpRequest>; params?: PostV7HyundaiSsoOtpParams },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7HyundaiSsoOtp>>,
  TError,
  { data: BodyType<SsoOtpRequest>; params?: PostV7HyundaiSsoOtpParams },
  TContext
> => {
  const mutationOptions = getPostV7HyundaiSsoOtpMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
